import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CompanyRegistrationService {

  baseUrl = environment.baseUrl;
  registration_form = new FormGroup({
    full_name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required]),
    mobile_no: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    confirm_password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    company_name: new FormControl('', [Validators.required]),
  });


  constructor(private http:HttpClient,) { }


  insert_registration_details(formData: any)
  { 
    return this.http.post(this.baseUrl + '/sign_up_company',{
      full_name : formData.full_name,
      email : formData.email,
      mobile_no : formData.mobile_no,
      company_name : formData.company_name, 
      password : formData.password
    });
  }

}
